import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Game, GameFormat } from '../../_shared/models/game.model';
import { Match } from '../../_shared/models/match.model';
import { PartnerConnectSet, PartnerConnectSide } from '../../_shared/models/partner-match.model';
import { Set } from '../../_shared/models/set.model';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';

@Injectable({
    providedIn: 'root'
})

export class PartnerConnectService {

    constructor(
        private http: HttpClient,
        private bhs: BoardHelpService
    ) { }

    getPartnerSides(match: Match) {
        const partnerConnectSides: PartnerConnectSide[] = [];
        match.sides.forEach((side, i) => {
            partnerConnectSides.push({
                sideNumber: side.sideNumber,
                participantName: this.bhs.getPlayersNames(match, side.sideNumber)
            });
        });

        return partnerConnectSides;
    }

    getPartnerConnectSets(match: Match) {

        const partnerConnectSets: PartnerConnectSet[] = [];
        match.sets.forEach((set, i) => {
            const server = match.sets?.length === i + 1 && this.bhs.getLastPoint(match)?.server?.sideNumber
                ? {
                    sideNumber: match.sets?.length === i + 1 ? this.bhs.getLastPoint(match)?.server?.sideNumber : null,
                    playerNumber: match.sets?.length === i + 1 ? this.bhs.getLastPoint(match)?.server?.playerNumber : null,
                }
                : null;
            partnerConnectSets.push({
                setNumber: set.setNumber || 0,
                side1Score: this.bhs.getGameScore(set, 1) || 0,
                side2Score: this.bhs.getGameScore(set, 2) || 0,
                side1PointScore: match.sets?.length === i + 1 ? this.bhs.getPointScore(match, 1) : null,
                side2PointScore: match.sets?.length === i + 1 ? this.bhs.getPointScore(match, 2) : null,
                side1TiebreakScore: this.getTiebreakScore(set, 1) || 0,
                side2TiebreakScore: this.getTiebreakScore(set, 2) || 0,
                server: server,
                winningSide: set.winningSide || 0,
                timestamp: set.timestamp || new Date(),
            });
        });
        return partnerConnectSets;
    }

    public getTiebreakScore(set: Set, sideNumber: number) {
        const lastGame: Game | null = set.games?.[set.games.length - 1] || null;
        let tiebreakScore: number | null = null;

        if (lastGame?.gameFormat === GameFormat.TIEBREAK && (lastGame?.side1Score + lastGame?.side2Score) > 0) {
            if (lastGame?.points?.length < 5) {
                return null;
            } else if (sideNumber === 1) {
                tiebreakScore = lastGame?.points?.[lastGame?.points?.length - 1]?.side1Score || null;
            } else {
                tiebreakScore = lastGame?.points?.[lastGame?.points?.length - 1]?.side2Score || null;
            }
        }

        return tiebreakScore;
    }

    getPartnerScore(match: Match, side = 1): string {
        let score = '';

        if (match.sets?.length) {
            match.sets?.forEach(set => {
                if (side === 1) {
                    score += `${this.bhs.getGameScore(set, 1)}-${this.bhs.getGameScore(set, 2)} `;
                } else {
                    score += `${this.bhs.getGameScore(set, 2)}-${this.bhs.getGameScore(set, 1)} `;
                }

                if (this.getTiebreakScore(set, 1) || this.getTiebreakScore(set, 2)) {
                    score += `(${this.getTiebreakScore(set, 1) > this.getTiebreakScore(set, 2) ? this.getTiebreakScore(set, 2) : this.getTiebreakScore(set, 1)}) `;
                }
            });

            if (match.sets?.length && match.matchStatus !== 'COMPLETED') {
                if (side === 1) {
                    score += `(${this.bhs.getPointScore(match, 1)}-${this.bhs.getPointScore(match, 2)}) `;
                } else {
                    score += `(${this.bhs.getPointScore(match, 2)}-${this.bhs.getPointScore(match, 1)}) `;
                }
            }
        } else {
            score = '0-0 (0-0)';
        }

        score = score.trim();

        return score;
    }
}
